const getActivityLevelAPI = (branchId, roleId, startDate, endDate, timezoneOffset) =>
  `api/stats/activity-level?branchId=${branchId}&roleId=${roleId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getInfractionsAPI = (branchId, roleId, startDate, endDate, timezoneOffset) =>
  `api/stats/infractions?branchId=${branchId}&roleId=${roleId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getTotalSpottedVehiclesAPI = (branchId, startDate, endDate, timezoneOffset) =>
  `api/stats/spotted-vehicles/total?branchId=${branchId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getSpottedVehiclesAPI = (branchId, startDate, endDate, timezoneOffset, currentPage, pageSize, search) =>
  `api/stats/spotted-vehicles?branchId=${branchId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}&currentPage=${currentPage}&pageSize=${pageSize}&search=${search}`;

const getTotalMissedRepossessionsAPI = (branchId, startDate, endDate, timezoneOffset) =>
  `api/stats/missed-repossessions/total?branchId=${branchId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getMissedRepossessionsAPI = (branchId, startDate, endDate, timezoneOffset, currentPage, pageSize, search) =>
  `api/stats/missed-repossessions?branchId=${branchId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}&currentPage=${currentPage}&pageSize=${pageSize}&search=${search}`;

const getTotalRepossessionsAPI = (branchId, startDate, endDate, timezoneOffset) =>
  `api/stats/repossessions/total?branchId=${branchId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getRepossessionsAPI = (branchId, startDate, endDate, timezoneOffset, currentPage, pageSize, search) =>
  `api/stats/repossessions?branchId=${branchId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}&currentPage=${currentPage}&pageSize=${pageSize}&search=${search}`;

const getHoursWorkedAPI = (branchId, startDate, endDate, timezoneOffset) =>
  `api/stats/hours-worked?branchId=${branchId}&start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getTotalCommissionsAPI = (branchId) => `api/shift-admin/active-shift-commissions/total?branchId=${branchId}`;

const getCommissionsAPI = (branchId, type, startDate, endDate, timezoneOffset, currentPage, pageSize, search) =>
  `api/shift-admin/active-shift-commissions/commissions?branchId=${branchId}&type=${type}&currentPage=${currentPage}&pageSize=${pageSize}&search=${search}`;

const getMyActivityLevelAPI = (startDate, endDate, timezoneOffset) =>
  `api/stats/activity-level/me?start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getMyInfractionsAPI = (startDate, endDate, timezoneOffset) =>
  `api/stats/infractions/me?start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getMySpottedVehiclesAPI = (startDate, endDate, timezoneOffset) =>
  `api/stats/spotted-vehicles/me?start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getMyRepossessionsAPI = (startDate, endDate, timezoneOffset) =>
  `api/stats/repossessions/me?start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getMyHoursWorkedAPI = (startDate, endDate, timezoneOffset) =>
  `api/stats/hours-worked/me?start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getUserInfractionsAPI = (userId, startDate, endDate, timezoneOffset, currentPage, pageSize, search) =>
  `api/stats/infractions/${userId}?start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}&currentPage=${currentPage}&pageSize=${pageSize}&search=${search}`;

const getMyCommissionsAPI = (startDate, endDate, timezoneOffset) =>
  `api/stats/commissions/me?start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getMyMissedOpportunitiesAPI = (startDate, endDate, timezoneOffset) =>
  `api/stats/missed-opportunities/me?start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getDayShiftsAPI = (userId, date, timezoneOffset) =>
  `api/stats/hours-worked/${userId}/day-shifts?date=${date}&timezoneOffset=${timezoneOffset}`;

const getDayExtraneousTimesAPI = (userId, date, timezoneOffset) =>
  `api/stats/hours-worked/${userId}/day-extraneous-times?date=${date}&timezoneOffset=${timezoneOffset}`;

// const driverMyStats = {
//   getTotalSpottedVehiclesAPI,
//   getTotalRepossessionsAPI,
//   getMyHoursWorkedAPI,
//   getMyActivityLevelAPI,
//   getMyInfractionsAPI,
//   getTotalCommissionsAPI,
//   getMyRepossessionsAPI,
//   getMySpottedVehiclesAPI,
//   getMyCommissionsAPI
// };

const getMyStatsDataAPI = ({ start, end, timezoneOffset, previousStart, previousEnd }) =>
  `api/stats/my-stats?start=${start}&end=${end}&timezoneOffset=${timezoneOffset}&previousStart=${previousStart}&previousEnd=${previousEnd}`;

export const statsEndpoints = {
  getActivityLevelAPI,
  getInfractionsAPI,
  getMyStatsDataAPI,
  getTotalMissedRepossessionsAPI,
  getMissedRepossessionsAPI,
  getTotalSpottedVehiclesAPI,
  getSpottedVehiclesAPI,
  getTotalRepossessionsAPI,
  getRepossessionsAPI,
  getHoursWorkedAPI,
  getTotalCommissionsAPI,
  getCommissionsAPI,
  getMyActivityLevelAPI,
  getMyInfractionsAPI,
  getMySpottedVehiclesAPI,
  getMyRepossessionsAPI,
  getMyHoursWorkedAPI,
  getMyCommissionsAPI,
  getUserInfractionsAPI,
  getDayShiftsAPI,
  getDayExtraneousTimesAPI,
  getMyMissedOpportunitiesAPI,
};
